import { useContext } from "react"

import { ThemeModeContext } from "../context/ThemeModeContext";

export const useThemeMode = () => {

	const themeModeContext = useContext(ThemeModeContext)
    
	if (themeModeContext === undefined) {
    	throw new Error("useThemeMode must be used within a ThemModeContext");
    }

    const getCurrentMode = () => {
        return themeModeContext.mode
    }

    const setCurrentMode = (mode:'light'|'dark'|'system') => {
        if(
            (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches && mode === 'system') || 
            mode === "dark" ) {
            document.body.style.backgroundColor = "var(--dark-bg)"
        }
        else {  
            document.body.style.backgroundColor = "var(--light-bg)"
        }
        themeModeContext.setMode(mode)
    }

    return {
        getCurrentMode: getCurrentMode,
        setCurrentMode: setCurrentMode
    }

}   